var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"call--area"},[_c('panel-call-details',_vm._b({scopedSlots:_vm._u([{key:"panel__header",fn:function(){return [_c('o-header',{attrs:{"showTimer":_vm.settings.showTimer,"timeBetweenCalls":_vm.settings.timeBetweenCalls,"callIsActive":!_vm.call.end,"isOnHold":_vm.call.isOnHold,"disableRecording":_vm.call.disableRecording,"callHasBeenConfirmed":_vm.call.confirmed,"callNumber":_vm.call.number,"workflow":_vm.workflow,"blockTypification":_vm.settings.blockTypification},on:{"record-call":_vm.clickToggleRecord,"hold-call":_vm.clickToggleHold,"stop-call":_vm.hangUpAndActiveteTimer,"type-call":function($event){_vm.show.typification = true},"trigger-new-request":_vm.resetAndExecuteNewRequest,"trigger-pause":function($event){_vm.workflow = 'pause'},"trigger-leave":function($event){_vm.workflow = 'leave'}}})]},proxy:true}])},'panel-call-details',{
            headerClass: 'call__header',
            data: {
                contactRequest: {
                    internalPersonProfile: _vm.settings.data.internalPersonProfile,
                    request: _vm.settings.data.request,
                    observations: _vm.settings.data.observations,
                    internalObservations: _vm.settings.data.internalObservations,
                    receptionDate: _vm.settings.data.receptionDate,
                    warnings: _vm.settings.data.contactWarnings,
                    callHistory: _vm.settings.data.contactCallHistory
                },
                script: _vm.settings.data.script
            },
            close: { show: false }
        },false)),(_vm.show.typification)?_c('modal',{key:_vm.call.end,attrs:{"form":{
            class: 'call__modal',
            settings: {
                id: 'formModalCall',
                typeOfPreparation: 'call'
            }
        },"customSettings":{
            color: 'green',
            class: 'call__modal__content',
            button: {
                label: 'confirmEvaluation'
            },
            show: {
                infoSection: false
            }
        },"preventReset":true},on:{"close":function($event){_vm.show.typification = false}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"call__modal__header"},[_vm._v(_vm._s(_vm.$t('global.callEvaluation')))])]},proxy:true},{key:"modal__body",fn:function(){return [_c('div',{staticClass:"cal__modal__body"},[_c('div',{staticClass:"call__modal__icons display--flex"},[_c('button-with-icon',{staticClass:"call__modal__icons__button",attrs:{"icon":{
                            component: function () { return import( /* webpackChunkName: 'IconPositive' */ '@/components/bundles/layout/images/icons/IconPositive' ); },
                                class: ("\n                                    call__modal__icon\n                                    call__modal__icon--green\n                                    pointer\n                                    " + (_vm.call.type === 'successful' ? 'call__modal__icon--green--active' : '') + "\n                                ")
                        },"action":{
                            execute: true,
                            function: _vm.chooseTypeOfState
                        }}}),_c('button-with-icon',{staticClass:"call__modal__icons__button",attrs:{"icon":{
                            component: function () { return import( /* webpackChunkName: 'IconReschedule' */ '@/components/bundles/layout/images/icons/IconReschedule' ); },
                            class: ("\n                                call__modal__icon\n                                call__modal__icon--reschedule\n                                pointer\n                                " + (_vm.call.type === 'rescheduling' ? 'call__modal__icon--reschedule--active' : '') + "\n                            ")
                        },"action":{
                            execute: true,
                            function: _vm.chooseTypeOfState,
                            param: 'rescheduling'
                        }}}),_c('button-with-icon',{staticClass:"call__modal__icons__button",attrs:{"icon":{
                            component: function () { return import( /* webpackChunkName: 'IconNegative' */ '@/components/bundles/layout/images/icons/IconNegative' ); },
                            class: ("\n                                call__modal__icon\n                                call__modal__icon--red\n                                pointer\n                                " + (_vm.call.type === 'unsuccessful' ? 'call__modal__icon--red--active' : '') + "\n                            ")
                        },"action":{
                            execute: true,
                            function: _vm.chooseTypeOfState,
                            param: 'unsuccessful'
                        }}})],1),(_vm.show.rescheduling)?_c('transition',{attrs:{"name":"call__modal--transition","appear":""}},[_c('div',{staticClass:"call__modal__rescheduling"},[_c('base-field',{staticClass:"call__modal__input",attrs:{"settings":{
                                label: { class: 'field__label--hide', text: _vm.$t('global.rescheduleTo') },
                                input: {
                                    component: 'InputCalendar',
                                    name: 'rescheduleTo',
                                    id: 'rescheduleTo',
                                    targetClass: 'field__input--default ty+pography--default color--default',
                                    value: _vm.getDateISO,
                                    browserAutocomplete: 'off',
                                    dynamicData: {
                                        configs: {
                                            mode: 'dateTime',
                                            is24hr: true,
                                            minDate: _vm.getDate,
                                            format: _vm.dateFormat,
                                            hideInput: true
                                        },
                                        isInline: true
                                    },
                                    isMissing: _vm.errors.missing.rescheduleTo,
                                    fileValidation: 'isAfterCertainDate',
                                    errors: [{
                                        type: 'isAfter', warning: _vm.$t('error.isAfter', { date: _vm.$t('global.beginDate') })
                                    }],
                                    errorOnSubmit: {
                                        show: _vm.errors.api.rescheduleTo ? true : false,
                                        messages: _vm.errors.api.rescheduleTo
                                    },
                                    validationParameter: _vm.getDate,
                                    noListener: true
                                },
                                allowFilling: true
                            }}}),_c('base-field',{staticClass:"call__modal__input call__modal__input--new-contact",attrs:{"settings":{
                                label: { class: 'capitalize', text: _vm.$t('global.newContact') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'newContactValue',
                                    name: 'newContactValue',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: '',
                                    browserAutocomplete: 'newContact',
                                    errorOnSubmit: {
                                        show: _vm.errors.api.newContactValue ? true : false,
                                        messages: _vm.errors.api.newContactValue
                                    },
                                    noListener: true
                                },
                                allowFilling: true
                            }}})],1)]):_vm._e(),_c('base-field',{staticClass:"call__modal__input",attrs:{"settings":{
                        label: { class: 'call__modal__label capitalize', text: _vm.$t('global.selectACause') },
                        input: {
                            component: 'InputAutocomplete',
                            id: 'stateId',
                            name: 'stateId',
                            type: 'text',
                            value: _vm.drop.value,
                            targetClass: 'field__input--default typography--default color--default',
                            browserAutocomplete: 'off',
                            isRequired: true,
                            isMissing: _vm.errors.missing.stateId,
                            dynamicData: {
                                data: _vm.call.states.drop
                            },
                            noListener: true
                        },
                        allowFilling: _vm.drop.active
                    }}}),(_vm.sendEmail.allowed)?_c('button',{staticClass:"call__modal__button--send-email background--transparent accessibility--button pointer color--green display--flex",class:{  'disable': _vm.loading },attrs:{"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();_vm.show.sendEmail = true; _vm.show.typification = false;}}},[_c('span',{staticClass:"display--block capitalize"},[_vm._v(_vm._s(_vm.$t('global.sendEmail')))]),_c('icon-send-email',{staticClass:"call__modal__button--send-email__icon"})],1):_vm._e()],1)]},proxy:true}],null,false,1667016945)}):_vm._e(),(_vm.show.sendEmail)?_c('modal',{key:"modalSendEmail",attrs:{"form":{
            class: 'send-email__modal',
            settings: {
                id: 'formModalSendEmail',
                typeOfPreparation: 'sendEmail'
            }
        },"customSettings":{
            color: 'green',
            class: 'send-email__modal__content',
            button: {
                label: 'sendEmail'
            },
            show: {
                infoSection: false
            }
        },"preventReset":true},on:{"close":function($event){_vm.show.sendEmail = false}},scopedSlots:_vm._u([{key:"modal__header",fn:function(){return [_c('h2',{staticClass:"send-email__modal__header"},[_vm._v(_vm._s(_vm.$t('global.sendEmail')))])]},proxy:true},{key:"modal__body",fn:function(){return [_c('div',{staticClass:"send-email__modal__body"},[_c('base-field',{staticClass:"send-email__modal__input send-email__modal__input--template",attrs:{"settings":{
                        label: { class: 'send-email__modal__label capitalize', text: _vm.$t('global.mailTemplates') },
                        input: {
                            component: 'InputAutocomplete',
                            id: 'templateId',
                            name: 'templateId',
                            type: 'text',
                            value: '',
                            targetClass: 'field__input--default typography--default color--default',
                            browserAutocomplete: 'off',
                            isRequired: true,
                            isMissing: _vm.errors.missing.templateId,
                            dynamicData: {
                                data: _vm.sendEmail.templates.drop
                            },
                            noListener: true
                        },
                        allowFilling: true
                    }}}),_c('base-field',{staticClass:"send-email__modal__input send-email__modal__input--email",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.email') },
                        input: {
                            component: 'InputBasic',
                            id: 'email',
                            name: 'email',
                            type: 'text',
                            class: 'field__input--default typography--default color--default',
                            value: '',
                            browserAutocomplete: 'email',
                            isRequired: true,
                            isMissing: _vm.errors.missing.email,
                            fileValidation: 'basicEmail',
                            errors: [{
                                type: 'email', warning: _vm.$t('error.email')
                            }],
                            errorOnSubmit: {
                                show: _vm.errors.api.email ? true : false,
                                messages: _vm.errors.api.email
                            }
                        },
                        allowFilling: true
                    }}})],1)]},proxy:true}],null,false,3715305210)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }